import React from 'react';
import { CollectionMockup } from './CollectionMockup';
import { productIntro, productName } from '../data/content';
export function ProductIntro() {
  return <section className="bg-ivory text-ink" data-id="element-154" data-mp="22jc5rj3f6ua6">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center sm:px-6 lg:py-20" data-id="element-155" data-mp="1noxts2i9wl50">
        <p className="font-sans text-[0.7rem] font-bold uppercase tracking-[0.2em] text-sage-deep sm:text-xs" data-id="element-156" data-mp="1smzeervcksil">
          {productIntro.eyebrow}
        </p>
        <h2 className="mt-3 font-display text-[2.5rem] font-semibold leading-none tracking-tight text-ink sm:text-6xl" data-id="element-157" data-mp="2gdlh03ml1kl7">
          {productName}
        </h2>
        <p className="mx-auto mt-4 max-w-lg font-sans text-[1.02rem] leading-relaxed text-ink/80 sm:text-lg" data-id="element-158" data-mp="26ns6l5y6fbij">
          {productIntro.body}
        </p>

        <div className="mx-auto mt-7 flex max-w-sm items-stretch justify-center divide-x divide-stone rounded-2xl border border-stone bg-ivory-card" data-id="element-159" data-mp="2bk0kyh4jv0on">
          {productIntro.stats.map(stat => <div key={stat.label} className="flex-1 px-4 py-4" data-id="element-160" data-mp="344h3qmc6lpll">
              <p className="font-display text-4xl font-semibold leading-none text-terra-deep" data-id="element-161" data-mp="uggn096bosai">{stat.value}</p>
              <p className="mt-1.5 font-sans text-[0.68rem] font-bold uppercase tracking-[0.12em] text-ink" data-id="element-162" data-mp="pi5djzjxwjst">
                {stat.label}
              </p>
            </div>)}
        </div>

        <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-163" data-mp="zd72auaazjuv">
          {productIntro.badges.map(badge => <li key={badge} className="rounded-full bg-ink px-3.5 py-1.5 font-sans text-[0.68rem] font-bold tracking-[0.14em] text-ivory" data-id="element-164" data-mp="1d89f81dki9h6">
              {badge}
            </li>)}
        </ul>

        <div className="mt-9" data-id="element-165" data-mp="1i4pz2jdqi1og">
          <CollectionMockup variant="covers" stage="deep" data-id="element-166" data-mp="1i5ssaxyj4g7j" />
        </div>
      </div>
    </section>;
}